import React from "react";
import PropTypes from "prop-types";
import lodash from "lodash";

class Filtering extends React.Component {
  render() {
    const { pool, dataPools, onImport, onAddRows, onReset } = this.props;

    return (
      <div className="row">
        <div className="col-md-4 col-xs-12">
          <select className="form-control" value={pool.id} onChange={this.changePool}>
            {dataPools.map(item => (
              <option key={item.id} value={item.id}>{item.location.name}: {item.name}</option>
            ))}
          </select>
        </div>

        <div className="col-md-8 col-xs-12">
          <div className="pull-right">
            <a
              className="btn btn-pink btn-raised btn-long margin-right-five"
              onClick={onImport}
            >
              IMPORT
            </a>
            <a
              className="btn btn-indigo btn-raised btn-long margin-right-five"
              onClick={onAddRows}
            >
              ADD ROWS
            </a>
            <a
              className="btn btn-grey btn-raised btn-long"
              onClick={onReset}
            >
              RESET
            </a>
          </div>
        </div>
      </div>
    )
  }

  changePool = e => {
    const pool = lodash.find(this.props.dataPools, {id: parseInt(e.target.value)});
    this.props.onChangePool(pool);
  };
}

Filtering.propTypes = {
  pool: PropTypes.object.isRequired,
  dataPools: PropTypes.array.isRequired,
  onChangePool: PropTypes.func.isRequired,
  onImport: PropTypes.func.isRequired,
  onAddRows: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired
};

export default Filtering;
